import { css } from "@emotion/react";
import Skeleton from "@mui/material/Skeleton";

import { colors } from "@dotnet/telematics-design-system";

import { TRI_SOURCES } from "shared/types/enums";

const FilteredTagLoader = () => {
    const { blue100 } = colors;

    return (
        <Skeleton
            data-testid={`tri-source-${TRI_SOURCES.Filtered}-tag-loader`}
            variant="rectangular"
            width={200}
            height={32}
            css={css({
                background: blue100,
                borderRadius: "4px"
            })}
        />
    );
};

export default FilteredTagLoader;
